// @vue/component
export default {
  name: 'ReportsFormExportItemDatepicker',

  props: {
    currentField: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      fieldValue: this.currentField.default_value,
    };
  },
};
